import ResetContainer from "./styles/resetStyles"

const Reset = () => {
  return (
    <ResetContainer>Reset</ResetContainer>
  )
}

export default Reset